/*
 * ROI Calculator
 *
 *
 */

'use-strict';

// Constants for calculation
const DESIGNER_HOURLY_RATE = 18.5;
const STAFF_HOURLY_RATE = 12;
const BRANDSTENCIL_COST_PER_MONTH = 198;
const BRANDSTENCIL_COST_PER_TEMPLATE = 550;
const BRANDSTENCIL_RESOURCES_PER_HOUR = 4;

export default function calculateROI(resourceCount, templateCount, monthCount) {
  let brandStencilResourceCost;
  let brandStencilTemplateCost;
  let brandStencilAccountCost;
  let brandStencilCreationCost;
  let internalCreationCost;
  // let externalCreationCost;
  // let averageCreationCost;
  let brandStencilTime;
  let traditionalTime;
  // Output
  let approxSaving;
  let approxTimeSaving;

  brandStencilResourceCost =
    (STAFF_HOURLY_RATE / BRANDSTENCIL_RESOURCES_PER_HOUR) * resourceCount;
  brandStencilTemplateCost = BRANDSTENCIL_COST_PER_TEMPLATE * templateCount;
  brandStencilAccountCost = BRANDSTENCIL_COST_PER_MONTH * monthCount;
  brandStencilCreationCost =
    brandStencilResourceCost +
    brandStencilTemplateCost +
    brandStencilAccountCost;

  internalCreationCost =
    (STAFF_HOURLY_RATE + DESIGNER_HOURLY_RATE) * resourceCount;

  approxSaving = internalCreationCost - brandStencilCreationCost;

  brandStencilTime = resourceCount / BRANDSTENCIL_RESOURCES_PER_HOUR;
  traditionalTime = resourceCount * 2; // <-- does this mean 2 hours? - should be a constant
  approxTimeSaving = traditionalTime - brandStencilTime;

  const savingsYearly = [approxSaving, approxTimeSaving];

  return savingsYearly;
}
